import { hostName } from 'shared/types/types'

export const isGeDomain = (): boolean => {
  const currentDomain = window.location.hostname

  const searchParams = new URLSearchParams(window.location.search)
  const isStage = searchParams.get('isStage') === 'true'

  if (isStage) {
    localStorage.setItem('isStage', 'true')
  }

  const savedIsStage = localStorage.getItem('isStage') === 'true'

  return currentDomain === hostName.GE || savedIsStage
}
